import { AMERICAN_YELLOW, RED_500, GREEN_500 } from '../../../constants';

const getStageTypeColor = (stageType?: string) => {
    if (stageType === 'won') return GREEN_500;
    if (stageType === 'lost') return RED_500;
    return AMERICAN_YELLOW;
};

export default getStageTypeColor;
